import { useEffect, useState } from "react";
import { Button, Label } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { apiPost } from "api/callApi";
import LevelDropdown from "components/LevelDropdown";
import { showAlert } from "utils/helper";

const MoveOccupant = (props) => {
  const {
    setOpenModalView = () => {},
    openModalView,
    occupantData,
    fetchData = () => {},
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const handleChange = (property, value) => {

    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  // Handle form submission for Add or Edit
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await apiPost(`/v1/occupant/move`, {
        levelId: data.levelId,
        occupantId: occupantData.id,
      });
      setLoading(false);
      setData("");
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      setOpenModalView(false);
      await fetchData();
    } catch (error) {
      setLoading(false);

      console.error("Error:", error);

      showAlert({
        title: "Error",
        text: error?.response?.data?.message || "An error occurred",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelModal = () => {
    setOpenModalView(false);
  };

  const AddModalData = () => {
    return (
      <div>
        <div style={{ marginTop: "20px" }}>
          <Label label={"Select Level"}>
            <div style={{ display: "flex", padding: "0px" }}>
              <LevelDropdown
                name="levelId"
                defaultValue={data?.levelId}
                projectId={occupantData.projectId}
                onChange={handleChange}
              />
            </div>
          </Label>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            margin: "200px 20px 20px 0px ",
          }}
        >
          <Button
            caption="Cancel"
            onClick={handleCancelModal}
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.colors.cancelButton,
              color: theme.colors.white,
              minWidth: "90px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
          />

          <Button
            caption={"Save"}
            isLoading={loading}
            onClick={handleSubmit}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "90px",
              height: "30px",
              borderRadius: "3px",
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {openModalView && (
        <BulkActionView
          title={"Move Occupant"}
          openModal={openModalView}
          renderBodyConditionally={AddModalData}
          handleCloseModal={() => {
            setOpenModalView(false);
            setData("");
          }}
        />
      )}
    </>
  );
};

export default MoveOccupant;
